import { getEnvVar } from 'helpers';

export const UNIT_TIME_BEFORE_ARRIVAL = 'unitTimeBeforeArrival';
export const UNIT_TIME_AFTER_CHECKOUT = 'unitTimeAfterCheckout';
export const UNIT_TIME_AFTER_ARRIVAL = 'unitTimeAfterArrival';
export const UNIT_TIME_BEFORE_CHECKOUT = 'unitTimeBeforeCheckout';
export const UNIT_TIME_AFTER_CONFIRMATION = 'unitTimeAfterConfirmation';
export const HOUR = 'HOUR';
export const DAY = 'DAY';

export const scheduleOptions = [
  {
    value: UNIT_TIME_BEFORE_ARRIVAL,
    label: 'Time before arrival'
  },
  {
    value: UNIT_TIME_AFTER_ARRIVAL,
    label: 'Time after arrival'
  },
  {
    value: UNIT_TIME_BEFORE_CHECKOUT,
    label: 'Time before checkout'
  },
  {
    value: UNIT_TIME_AFTER_CHECKOUT,
    label: 'Time after checkout'
  },
  {
    value: UNIT_TIME_AFTER_CONFIRMATION,
    label: 'Time after confirmation'
  }
];

export const scheduleUnitOptions = [
  {
    value: HOUR,
    label: 'Hours'
  },
  {
    value: DAY,
    label: 'Days'
  }
];
